<template>
  <a-row class="bottom-content">
    <a-col :span="6" class="bottom-content-left">
      <left-tabs
        :selectedKeys="selectedKeys"
        :loading="loading"
        :sendMachine="sendMachine"
        @changeTab="changeTab"
        @selectTree="selectTree"
        @selectedInfo="selectedInfo"
        @load="loadTree"
      ></left-tabs>
    </a-col>
    <a-col :span="18" style="height: 100%;">
      <a-spin size="large" v-if="loading" :spinning="loading" class="spin-custom"> </a-spin>
      <component
        :is="componentId"
        :treeInfo="treeInfo"
        :fileType="fileType"
        :selectedKey="selectedKeys.length ? selectedKeys[0] : ''"
        :canTransmission="canTransmission"
        :bottomUplod="bottomUplod"
        :sendMachine="sendMachine"
        @downloadProgram="downloadProgram"
        @downloadFile="downloadFile"
        @downloadInternal="downloadInternal"
      ></component>
    </a-col>
  </a-row>
</template>

<script>
import LeftTabs from './LeftTabs.vue' // tab选择
import InternalGateway from './InternalGateway.vue' // 内部网关
import CloudPath from './CloudPath.vue' // 云端路径
export default {
  components: {
    LeftTabs,
    InternalGateway,
    CloudPath
  },
  props: {
    fileType: {
      type: String,
      default: 'file'
    },
    canTransmission: {
      type: Boolean,
      default: true
    },
    bottomUplod: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabKey: '',
      selectedKeys: [],
      treeInfo: {},
      loading: false,
      sendMachine: 'a'
    }
  },
  computed: {
    componentId() {
      let key = ''
      switch (this.tabKey) {
        case '1':
          key = 'internal-gateway'
          break
        case '2':
          key = 'cloud-path'
          break
        default:
          key = 'internal-gateway'
          break
      }
      return key
    }
  },
  methods: {
    loadTree(value) {
      this.loading = value
    },
    downloadProgram() {
      this.$emit('downloadProgram', this.treeInfo)
    },
    downloadFile() {
      this.$emit('downloadFile', this.treeInfo)
    },
    downloadInternal() {
      this.$emit('downloadInternal', this.treeInfo)
    },
    changeTab(value) {
      this.tabKey = value
    },
    selectTree(selectedKeys) {
      this.selectedKeys = selectedKeys
    },
    selectedInfo(value) {
      this.treeInfo = value
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-content {
  height: calc(50% - 4px);
  width: 100%;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &-left {
    border-right: 1px solid #d8d8d8;
    height: 100%;
    overflow: hidden;
  }
  .spin-custom {
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: hsla(213, 100%, 94%, 0.75);
    z-index: 8;
  }
}
</style>
